<section class="dashboard">
  <div class="dashboard-header">
    <div class="user-info">
      <img [src]="user.picture" alt="user avatar" class="avatar" />
      <div>
        <h2>{{ user.nickname }}</h2>
        <p>{{ user.email }}</p>
      </div>
    </div>
    <div class="settings">
      <button class="icon-btn"><i class="ph ph-gear"></i></button>
    </div>
  </div>

  <div class="insights-header">
    <div class="title-group">
      <h3>Behavioral Insights</h3>
      <p>Key engagement metrics for your site</p>
    </div>

    <app-site-selector
      [sites]="sites"
      [(selectedSite)]="selectedSite"
      (siteChanged)="onSiteChange($event)">
    </app-site-selector>
  </div>

  <div class="stats-grid">
    <div class="stat-card">
      <h3>Visitors</h3>
      <p class="value">{{ 234 }}</p>
      <span class="trend up">+8%</span>
    </div>
    <div class="stat-card">
      <h3>Bounce Rate</h3>
      <p class="value">{{ 3.4 }}%</p>
      <span class="trend down">–1.4%</span>
    </div>
    <div class="stat-card">
      <h3>Emails Sent</h3>
      <p class="value">{{ 1 }}</p>
      <span class="trend flat">Stable</span>
    </div>
    <div class="stat-card">
      <h3>Form Submissions</h3>
      <p class="value">{{ '3,432' }}</p>
      <span class="trend up">+12%</span>
    </div>
  </div>

  <!-- Regular Tools -->
  <h3 class="section-title">Tools & Access</h3>
  <div class="tools-grid">
    <a class="tool-card" href="#">
      <i class="ph ph-user-circle"></i>
      <h4>Profile</h4>
      <p>Manage account settings</p>
    </a>

    <a class="tool-card" href="#" target="_blank">
      <i class="ph ph-credit-card"></i>
      <h4>Billing</h4>
      <p>Open customer portal</p>
    </a>

    <a class="tool-card" href="/modal-builder">
      <i class="ph ph-code"></i>
      <h4>Modal Builder</h4>
      <p>Launch editor</p>
    </a>

    <a class="tool-card" href="#" (click)="logout()">
      <i class="ph ph-sign-out"></i>
      <h4>Logout</h4>
      <p>Sign out of account</p>
    </a>
  </div>

  <!-- Admin Config Section -->
  <h3 class="section-title">Admin Configuration</h3>
  <div class="tools-grid admin-tools">
    <a class="tool-card" href="/admin/accounts">
      <i class="ph ph-users-three"></i>
      <h4>Account Manager</h4>
      <p>Manage users and sites for each account</p>
    </a>

    <a class="tool-card" href="/admin/users">
      <i class="ph ph-identification-badge"></i>
      <h4>User Manager</h4>
      <p>Invite users and edit access levels</p>
    </a>

    <a class="tool-card" href="/admin/sites">
      <i class="ph ph-globe-hemisphere-west"></i>
      <h4>Site Manager</h4>
      <p>View and edit client sites</p>
    </a>
  </div>

  <!-- Demo Section -->
  <h3 class="section-title">Demos</h3>
  <div class="tools-grid admin-tools">
    <a class="tool-card" href="/admin/demo">
      <i class="ph ph-users-three"></i>
      <h4>PontRx</h4>
      <p>Building PontRx from Zero to One</p>
    </a>
  </div>

  <div class="json-panel">
    <h3>Your JSON Profile</h3>
    <pre><code [highlight]="profileJson"></code></pre>
  </div>
</section>
